var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RowList',{attrs:{"products":_vm.products,"title":"相關推薦","curationGuid":"recommend"}})}
var staticRenderFns = []

export { render, staticRenderFns }